import CatalogTopMenu from '@components/catalog/CatalogTopMenu'
import CategoryOrderGrid from '@components/catalog/category/categoryOrder/CategoryOrderGrid'
import CategorySubMenu from '@components/catalog/category/CategorySubMenu'
import React from 'react'
import { Nav, Navbar } from 'rsuite'

export default function CatalogCategoriesOrderPage () {
  

  return (
    <div className="CatalogCategoriesPage">
      <h1 className="u-heading">Категории</h1>
      <CatalogTopMenu />
      <CategorySubMenu />
      
      <CategoryOrderGrid />
    </div>
  )
}